// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolRayType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";

export let BaseGannDataCacheTool = function ()
{
    DataCacheTool.apply(this);
    this.InitBlock();
};

BaseGannDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

BaseGannDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);
    this.mirrored = false;
    this.RayType = DataCacheToolRayType.Ray;
};